export { default } from "./AttributeColumnConfig";
